module.exports = "/wp-content/plugins/farmacy/assets/js/images/kiosk_backround_leaves-c2b5bd4ba1133b9cd2ddc819dbdc247b.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/kiosk_backround_leaves.jpg
 ** module id = 669
 ** module chunks = 1 75 88
 **/